/**
 * MIDDLEWARE_PROVIDERS
 */

import { Injectable } from '@angular/core';
import { createLogger } from 'redux-logger';
import {
  combineEpics,
  createEpicMiddleware,
  Epic,
  EpicMiddleware,
} from 'redux-observable';
import { Middleware } from 'redux';
import { IEpicsService } from '@shared/types';
import { environment } from '../../../environments/environment';
import {
  UiEpics,
  ApiEpics,
  SessionEpics,
  XprtDataEpics,
  ToolsEpics,
  EventsEpics,
} from '../epics';

@Injectable()
export class MiddlewaresProvider {
  public static disableReduxLogger: boolean = false;
  private middlewares: Middleware[] = [];
  private rootEpic: Epic<any, any>;
  private epicsMiddleware: EpicMiddleware<any, any, any>;

  // eslint-disable-next-line max-params
  public constructor(
    // Epics
    public apiEpics: ApiEpics,
    public uiEpics: UiEpics,
    public sessionEpics: SessionEpics,
    public xprtDataEpics: XprtDataEpics,
    public toolsEpics: ToolsEpics,
    public eventsEpics: EventsEpics,
  ) {
    const epicsServices: IEpicsService[] = [
      this.xprtDataEpics,
      this.apiEpics,
      this.uiEpics,
      this.sessionEpics,
      this.toolsEpics,
      this.eventsEpics,
    ];
    this.rootEpic = combineEpics(
      ...epicsServices.map((service) => service.getEpic()),
    );
    this.epicsMiddleware = createEpicMiddleware();
    const mdw: Middleware[] = [];

    if (
      (environment.envName === 'development' ||
        environment.envName === 'local') &&
      !MiddlewaresProvider.disableReduxLogger
    ) {
      mdw.push(this.getLoggerMiddleware());
    }

    this.middlewares.push(...mdw);
  }

  public getMiddlewares(): Middleware[] {
    return this.middlewares;
  }

  public getEpicMiddleware(): EpicMiddleware<any, any, any, any> {
    return this.epicsMiddleware;
  }

  public getRootEpic(): Epic<any, any> {
    return this.rootEpic;
  }

  private getLoggerMiddleware(): Middleware {
    return createLogger({
      level: 'info',
      collapsed: true,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      titleFormatter: (action, time, took): string => {
        const parts: string[] = [`action`];
        parts.push(`@ ${time}`);
        parts.push(action.type);

        if (action.payload && action.payload.entity_type) {
          parts.push(`==> ${action.payload.entity_type} <==`);
        }

        return parts.join(` `);
      },
      colors: {
        title: (action): string => {
          if (action.payload && action.payload.entity_type) {
            return '#286090';
          }
        },
      },
    });
  }
}

export const MIDDLEWARE_PROVIDERS: any[] = [
  { provide: MiddlewaresProvider, useClass: MiddlewaresProvider },
];
